'use client';

import {
  type MotionValue,
  useMotionValue,
  useTransform,
} from 'framer-motion';
import type { HeroBackgroundPrismConfig } from './Cherobackground.constants';

interface UseCherobackgroundMotionValuesInput {
  prismConfig: HeroBackgroundPrismConfig;
  scrollY: MotionValue<number>;
}

export interface CherobackgroundMotionValues {
  entryProgress: MotionValue<number>;
  glow: MotionValue<number>;
  scale: MotionValue<number>;
}

export function useCherobackgroundMotionValues({
  prismConfig,
  scrollY,
}: UseCherobackgroundMotionValuesInput): CherobackgroundMotionValues {
  const entryProgress = useMotionValue(0);
  const scrollProgress = useTransform(scrollY, (value) =>
    Math.max(0, Math.min(1, value / prismConfig.scrollRangePx)),
  );

  const glow = useTransform([entryProgress, scrollProgress], (values) => {
    const [entry, scroll] = values as number[];
    if (entry < 1) {
      return prismConfig.glow * Math.max(0, (entry - 0.5) * 2);
    }

    return prismConfig.glow - (prismConfig.scrollMaxGlow - prismConfig.glow) * scroll;
  });

  const scale = useTransform([entryProgress, scrollProgress], (values) => {
    const [entry, scroll] = values as number[];
    if (entry < 1) {
      return prismConfig.scale * entry;
    }

    return prismConfig.scale + (prismConfig.scrollMaxScale - prismConfig.scale) * scroll;
  });

  return { entryProgress, glow, scale };
}
